import api from '../utilities/api';

export default {
    info(accessToken) {
        return api.v2.get(`hcpc-portal/${accessToken}/info`);
    },
    summary(accessToken) {
        return api.v2.get(`hcpc-portal/${accessToken}/summary`);
    },
    updateSummary(accessToken, summary) {
        return api.v2.put(`hcpc-portal/${accessToken}/summary`, {summary: summary});
    },
    entries(accessToken) {
        return api.v2.get(`hcpc-portal/${accessToken}/entries`);
    },
    statement(accessToken) {
        return api.v2.get(`hcpc-portal/${accessToken}/statement`);
    },
    updateStatement(accessToken, statement) {
        return api.v2.put(`hcpc-portal/${accessToken}/statement`, statement);
    },
    evidence(accessToken, selectedEntries) {
        return api.v2.get(`hcpc-portal/${accessToken}/evidence`, {params: {entryId: selectedEntries}});
    },
    evidenceMetadata(accessToken, storageId) {
        return api.v2.get(`hcpc-portal/${accessToken}/evidence/${storageId}`);
    }
}
